import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { UrgencyBar } from './UrgencyBar';
export const Header = () => {
  return <header className="bg-black text-bttf-text border-b border-christmas-gold/30 z-50 sticky top-0" data-id="element-191">
      {/* Christmas Banner */}
      <div className="bg-gradient-christmas text-white text-center py-2 px-4 relative overflow-hidden" data-id="element-192">
        <div className="absolute inset-0 opacity-20" data-id="element-193">
          <div className="absolute top-0 left-0 text-2xl animate-twinkle" data-id="element-194">
            ⭐
          </div>
          <div className="absolute top-0 right-0 text-2xl animate-twinkle" style={{
          animationDelay: '0.5s'
        }} data-id="element-195">
            ⭐
          </div>
        </div>
        <p className="text-sm md:text-base font-bold relative z-10 flex items-center justify-center gap-2" data-id="element-196">
          <span className="text-christmas-gold" data-id="element-197">🎄</span>
          <span data-id="element-198">SPECIAL CHRISTMAS EDITION - LIMITED HOLIDAY RELEASE</span>
          <span className="text-christmas-gold" data-id="element-199">🎄</span>
        </p>
      </div>

      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-200">
        <div className="flex items-center space-x-2" data-id="element-201">
          <BookOpenIcon className="h-6 w-6 text-christmas-gold shadow-christmas-glow" data-id="element-202" />
          <span className="font-bold text-lg bg-gradient-festive text-transparent bg-clip-text" data-id="element-203">
            BTTF 40th Anniversary
          </span>
          <span className="text-2xl animate-float" data-id="element-204">🎅</span>
        </div>
        <nav data-id="element-205">
          <ul className="flex space-x-3 md:space-x-6 items-center" data-id="element-206">
            <li className="hidden md:block" data-id="element-207">
              <a href="#book" className="text-bttf-text hover:text-christmas-gold transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-christmas-gold after:transition-all" data-id="element-208">
                The Book
              </a>
            </li>
            <li className="hidden md:block" data-id="element-209">
              <a href="#pricing" className="text-bttf-text hover:text-christmas-gold transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-christmas-gold after:transition-all" data-id="element-210">
                Editions
              </a>
            </li>
            <li data-id="element-211">
              <a href="#pricing" className="bg-gradient-christmas hover:opacity-90 text-white font-bold px-3 py-2 sm:px-4 sm:py-2 rounded-md transition-all shadow-md hover:shadow-christmas-glow text-sm sm:text-base whitespace-nowrap" data-id="element-212">
                🎁 Get My Copy
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <UrgencyBar data-id="element-213" />
    </header>;
};